import { render, staticRenderFns } from "./NewPageButton.vue?vue&type=template&id=213b3511&"
import script from "./NewPageButton.vue?vue&type=script&lang=js&"
export * from "./NewPageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports